/**
 * Debug: find what clears Shopify discount compare-at on the cart subtotal.
 *
 * Enable: window.cartSubtotalDebug = true (default on)
 * Disable: window.cartSubtotalDebug = false
 *
 * Look for console groups prefixed with [cart-subtotal-debug]
 */
(function () {
  if (window.__cartSubtotalDebugInstalled) return;
  window.__cartSubtotalDebugInstalled = true;
  if (typeof window.cartSubtotalDebug === 'undefined') {
    window.cartSubtotalDebug = true;
  }

  const PREFIX = '[cart-subtotal-debug]';

  function enabled() {
    return window.cartSubtotalDebug !== false;
  }

  function log(label, detail) {
    if (!enabled()) return;
    if (detail !== undefined) console.log(PREFIX, label, detail);
    else console.log(PREFIX, label);
  }

  function warn(label, detail) {
    if (!enabled()) return;
    if (detail !== undefined) console.warn(PREFIX, label, detail);
    else console.warn(PREFIX, label);
  }

  function stack() {
    try {
      throw new Error('cart-subtotal-debug stack');
    } catch (error) {
      return String(error.stack || '')
        .split('\n')
        .slice(2, 18)
        .map((line) => line.trim())
        .join('\n');
    }
  }

  function describeSubtotal(el) {
    if (!el) return null;
    return {
      text: (el.textContent || '').replace(/\s+/g, ' ').trim(),
      html: (el.innerHTML || '').trim().slice(0, 300),
      classes: el.className,
      hasCompareClass: el.classList.contains('cart-subtotal--compare'),
      hasCompareMarkup: Boolean(
        el.querySelector('.cart-subtotal__compare, .shopify-discount-subtotal-prices, .cart-subtotal__original, s')
      ),
      originalCents: el.dataset?.originalLineTotalCents || null,
      totalCents: el.dataset?.cartTotalCents || null,
      discountCents: el.dataset?.cartDiscountCents || null,
    };
  }

  function findSubtotals(root) {
    const scope = root && root.querySelectorAll ? root : document;
    return Array.from(
      scope.querySelectorAll(
        '.cart-drawer__footer .totals__total-value, #main-cart-footer .totals__total-value, .dynamic-subtotal'
      )
    );
  }

  function snapshotAll(label) {
    const items = findSubtotals(document).map(describeSubtotal);
    log(label, items);
    return items;
  }

  function htmlHasCompare(html) {
    if (!html) return false;
    return (
      html.includes('cart-subtotal--compare') ||
      html.includes('cart-subtotal__compare') ||
      html.includes('shopify-discount-subtotal-prices') ||
      html.includes('cart-subtotal__original')
    );
  }

  function isSubtotalRelated(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches?.('.totals__total-value, .dynamic-subtotal, .cart-subtotal__compare, .cart-drawer__footer, .drawer__footer, .drawer__inner, #CartDrawer, cart-drawer')) {
      return true;
    }
    if (node.querySelector?.('.totals__total-value, .cart-subtotal--compare, .dynamic-subtotal')) {
      return true;
    }
    if (node.closest?.('.cart-drawer__footer, .drawer__footer, .totals__total-value, cart-drawer, #CartDrawer')) {
      return true;
    }
    return false;
  }

  // --- Patch DOM writers that commonly clear Liquid compare-at ---
  const nativeInnerHTML = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
  if (nativeInnerHTML?.set) {
    Object.defineProperty(Element.prototype, 'innerHTML', {
      configurable: true,
      enumerable: nativeInnerHTML.enumerable,
      get: nativeInnerHTML.get,
      set(value) {
        const related = isSubtotalRelated(this);
        const before = related ? findSubtotals(document).map(describeSubtotal) : null;
        const incomingHasCompare = related ? htmlHasCompare(String(value)) : null;

        if (related && enabled()) {
          const isTotalsValue = this.classList?.contains('totals__total-value');
          const groupFn = isTotalsValue ? console.group : console.groupCollapsed;
          groupFn.call(
            console,
            `${PREFIX} innerHTML set on <${this.tagName.toLowerCase()}>#${this.id || ''} .${String(this.className || '').slice(0, 80)}`
          );
          log('incoming HTML has compare-at?', incomingHasCompare);
          log('incoming value', String(value).slice(0, 400));
          log('subtotals BEFORE', before);
          console.log(PREFIX, 'STACK:\n' + stack());
          if (String(this.className || '').includes('tpo_') || String(value).includes('tpo_')) {
            warn('Likely Easify Product Options (TPO) — class tpo_* detected');
          }
        }

        nativeInnerHTML.set.call(this, value);

        if (related && enabled()) {
          const after = findSubtotals(document).map(describeSubtotal);
          log('subtotals AFTER', after);
          const lost = (before || []).some((b) => b?.hasCompareMarkup) && after.every((a) => !a?.hasCompareMarkup);
          if (lost || ((before || []).some((b) => b?.hasCompareClass) && !incomingHasCompare)) {
            warn('COMPARE-AT LIKELY CLEARED by this innerHTML write', {
              target: `${this.tagName}#${this.id}`,
              incomingHasCompare,
            });
          }
          console.groupEnd();
        }
      },
    });
  }

  const nativeReplaceChildren = Element.prototype.replaceChildren;
  if (nativeReplaceChildren) {
    Element.prototype.replaceChildren = function (...nodes) {
      const related = isSubtotalRelated(this);
      if (related && enabled()) {
        console.groupCollapsed(`${PREFIX} replaceChildren on <${this.tagName.toLowerCase()}>`);
        log('subtotals BEFORE', findSubtotals(document).map(describeSubtotal));
        log('stack', stack());
      }
      const result = nativeReplaceChildren.apply(this, nodes);
      if (related && enabled()) {
        log('subtotals AFTER', findSubtotals(document).map(describeSubtotal));
        console.groupEnd();
      }
      return result;
    };
  }

  // --- MutationObserver on cart drawer ---
  function bindObserver() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.__cartSubtotalDebugObserved) return;
    drawer.__cartSubtotalDebugObserved = true;

    let lastSignature = '';

    const observer = new MutationObserver((mutations) => {
      if (!enabled()) return;

      const subtotals = findSubtotals(document);
      const signature = subtotals.map((el) => el.innerHTML).join('||');
      if (signature === lastSignature) return;

      const hadCompare = lastSignature.includes('cart-subtotal__original') || lastSignature.includes('cart-subtotal--compare');
      const hasCompare = subtotals.some(
        (el) =>
          el.classList.contains('cart-subtotal--compare') ||
          el.querySelector('.cart-subtotal__original, .cart-subtotal__compare')
      );

      lastSignature = signature;

      if (hadCompare && !hasCompare) {
        console.groupCollapsed(`${PREFIX} MutationObserver: compare-at DISAPPEARED`);
        warn('compare-at was present, now gone');
        log('mutations', mutations.slice(0, 12).map((m) => ({
          type: m.type,
          target: `${m.target?.nodeName || ''}.${m.target?.className || ''}`.slice(0, 120),
          added: m.addedNodes?.length,
          removed: m.removedNodes?.length,
        })));
        log('subtotals now', subtotals.map(describeSubtotal));
        log('stack at observation time (async — may not be the writer)', stack());
        console.groupEnd();
      } else if (!hadCompare && hasCompare) {
        log('MutationObserver: compare-at APPEARED', subtotals.map(describeSubtotal));
      } else {
        log('MutationObserver: subtotal DOM changed', subtotals.map(describeSubtotal));
      }
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-original-line-total-cents', 'data-cart-total-cents'],
    });

    log('observing cart-drawer for subtotal compare-at changes');
    snapshotAll('initial snapshot');
  }

  // Public helpers
  window.cartSubtotalDebugSnapshot = () => snapshotAll('manual snapshot');
  window.cartSubtotalDebugDescribe = describeSubtotal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindObserver);
  } else {
    bindObserver();
  }

  // Re-bind after late cart-drawer mounts
  document.addEventListener('cart:updated', () => {
    log('event cart:updated');
    snapshotAll('after cart:updated');
    bindObserver();
  });

  document.addEventListener('pubsub:cart-update', () => {
    log('event pubsub:cart-update');
  });

  log('installed — open cart and watch for [cart-subtotal-debug] groups. Disable with window.cartSubtotalDebug = false');
})();
